<template>
  <bottom-bar-layout class="million-read-user-guide"
                     :show-bar="true"
                     :bar-height="118"
                     :show-consult="false"
                     :shadow="false"
                     barBackground="transparent"
  >
    <div class="million-read-user-guide-content">
      <img :src="require('@/assets/img/million_read/user_guide/01_01.png')" />
      <div class="million-read-user-guide-video-block">
        <img :src="require('@/assets/img/million_read/user_guide/01_02.png')" />
        <div class="video"
             :class="{ 'in-app': inAppWebView }"
        >
          <video src="https://res.youthmba.com/prod/million/million_user_guide_updated.mp4"
                 :poster="require('@/assets/img/million_read/user_guide/poster.png')"
                 controls
          />
        </div>
      </div>
      <img :src="require('@/assets/img/million_read/user_guide/02.png')" />
      <img :src="require('@/assets/img/million_read/user_guide/03.png')" />
      <img :src="require('@/assets/img/million_read/user_guide/04_01.png')" />
      <img :src="require('@/assets/img/million_read/user_guide/04_02.gif')" />
      <img :src="require('@/assets/img/million_read/user_guide/04_03.png')" />
      <img :src="require('@/assets/img/million_read/user_guide/04_04.gif')" />
      <img :src="require('@/assets/img/million_read/user_guide/04_05.png')" />
      <img :src="require('@/assets/img/million_read/user_guide/05.png')" />
    </div>
    <template #tabbar>
      <div class="million-read-user-guide-footer-btn"
           v-ym-report:MILLION_VIP_GUIDE_GO_LEARNING_CLICK=""
           @click="handleClickBtn"
      >
        {{ buttonText }}
      </div>
    </template>
  </bottom-bar-layout>
</template>

<script>
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import { getStaticShareInfo } from '@/services/app';
  import { handleRedirectAPPPage, isAppWebView, locationHref } from '@/utils';

  export default {
    name: 'MillionReadUserGuide',
    metaInfo: {},
    components: {
      BottomBarLayout,
    },
    data() {
      return {
        appUrl: 'https://oia.youthmba.com/download/app?scheme=youthmba%3A%2F%2Fmillion%2Fweb%3Furl%3Dhttps%3A%2F%2Fm.youthmba.com%2Fmillion%2Fread%2Fselect',
      };
    },
    computed: {
      type() {
        return this.$route.query && this.$route.query.type ? this.$route.query.type : '';
      },
      inAppWebView() {
        return isAppWebView();
      },
      buttonText() {
        if (this.inAppWebView) {
          return this.type === 'learn' ? '去读书' : '去选书';
        }
        return '马上下载APP去学习';
      },
    },
    methods: {
      handleClickBtn() {
        if (this.inAppWebView) {
          const appReadPage = 'youthmba://million/read?type=readHome';
          const appSelectPage = 'youthmba://million/read?type=selectHome';
          const path = this.type === 'learn' ? appReadPage : appSelectPage;
          handleRedirectAPPPage(path);
          return;
        }
        locationHref(this.appUrl);
      },
      async getStaticShareInfo() {
        await getStaticShareInfo({
          type: 'MillionUseGuide',
        });
      },
    },
    created() {
      this.getStaticShareInfo();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  /deep/ .page-content {
    padding-bottom: 0 !important;
  }

  .million-read-user-guide {
    &-content {
      width: 100%;
      /deep/ img {
        width: 100%;
        display: block;
      }
    }
    &-footer-btn {
      width: 56%;
      height: 88px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-text-base;
      font-size: 34px;
      font-weight: @font-weight-strong;
      line-height: 1;
      border-radius: 44px;
      background: #fed100;
    }
    &-video-block {
      position: relative;
      .video {
        position: absolute;
        top: 0;
        left: 5%;
        display: block;
        width: 90%;
        height: 386px;
        &.in-app {
          height: 51vw;
        }
        video {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 12px;
        }
      }
    }
  }

</style>
